// English translations — CityDates i18n

const en = {
  // App
  app: {
    name: 'CityDates',
    tagline: 'Real dates in Bulgarian cities',
  },

  // Auth
  auth: {
    login: 'Login',
    register: 'Register',
    email: 'Email address',
    password: 'Password',
    yourName: 'Your name',
    enterGame: 'Enter the game',
    createAccount: 'Create account',
    continueWithGoogle: 'Continue with Google',
    or: 'or',
    testAccounts: 'Test accounts',
    termsNote: 'By logging in, you accept our Terms of Service',
    welcomeBack: 'Welcome back!',
    accountCreated: 'Account created! Welcome to CityDates!',
    fillAllFields: 'Please fill in all fields.',
    enterName: 'Enter your name.',
    wrongCredentials: 'Wrong email or password.',
    emailExists: 'An account with this email already exists.',
    googleError: 'Google login error: ',
    loginError: 'Login error.',
  },

  // Navigation
  nav: {
    play: 'Play',
    social: 'Social',
    cityMap: 'City Map',
    checkIn: 'Check In',
    location: 'Location',
    chat: 'Chat',
    discovery: 'Discover Players',
    profile: 'Profile',
    likes: 'Likes',
    credits: 'Credits',
    buyCredits: '+ Buy Credits',
    notifications: 'Notifications',
    settings: 'Settings',
    logout: 'Logout',
    logoutSuccess: 'Logged out successfully.',
    logoutError: 'Logout error.',
    mood: 'Mood',
    money: 'Money',
    energy: 'Energy',
    online: 'Online',
  },

  // Character creation
  character: {
    step: 'Step',
    of: 'of',
    makeChoice: 'Please make a choice before continuing.',
    next: 'Next',
    back: 'Back',
    create: 'Create character',
    creating: 'Creating...',
    created: 'Character created! Welcome to CityDates!',
    enterName: 'Enter your character name.',

    whoIsYourChar: 'Who is your character?',
    genderDesc: 'Gender choice determines your character\'s clothing, hairstyles and social dynamics.',
    male: 'Male',
    female: 'Female',
    maleDesc: 'Male character with male clothing, hairstyles and social dynamics',
    femaleDesc: 'Female character with female clothing, hairstyles and social dynamics',
    genderNote: '💡 Gender choice does not limit who you date — that is set in the next step.',

    whoDoYouLike: 'Who do you like?',
    orientationDesc: 'This determines which profiles you will see in the game.',
    men: 'Men',
    women: 'Women',
    both: 'Both',

    chooseCity: 'Which city do you live in?',
    cityDesc: 'The city determines the map, locations and players around you.',

    whatIsLife: 'What is your character\'s life like?',
    lifeProfileDesc: 'The profile is not just cosmetic — it determines money, work, style, confidence and social environment.',
    pointBudget: 'Point budget',
    pointsLeft: 'points left',
    pointsOver: 'points over',
    resetStats: 'Reset',
    appearance: 'Appearance',
    budget: 'Budget',
    social: 'Social',
    career: 'Career',

    createVisual: 'Create your visual character',
    avatarDesc: 'Customize how your character looks. You can change everything later.',
    uploadPhoto: 'Upload photo',
    uploadPhotoDesc: 'Upload your photo and AI will generate an avatar that looks like you',
    analyzePhoto: 'Analyze photo',
    analyzing: 'Analyzing...',
    generatingAvatar: 'Generating avatar...',
    avatarGenerated: 'Avatar generated!',
    photoAnalyzed: 'Photo analyzed! Generating avatar...',
    uploadError: 'Error uploading photo.',
    hair: 'Hair',
    body: 'Body',
    features: 'Features',
    height: 'Height',
    hairStyle: 'Hair style',
    hairColor: 'Hair color',
    bodyType: 'Body type',
    skinTone: 'Skin tone',
    eyeColor: 'Eye color',
    facialFeatures: 'Facial features (choose up to 2)',
    heightLabel: 'Height',
    cm: 'centimeters',
    charPreview: 'Character preview',
    chooseAbove: 'Choose characteristics above',

    confirmTitle: 'Confirm character',
    charName: 'Character name',
    charAge: 'Age',
    years: 'years',
  },

  // City map
  cityMap: {
    title: 'City Map',
    searchLocation: 'Search location...',
    playersIn: 'Players in',
    playersInVarna: 'Players in Varna',
    playersInSofia: 'Players in Sofia',
    playersInPlovdiv: 'Players in Plovdiv',
    playersInBurgas: 'Players in Burgas',
    open: 'Open',
    closed: 'Closed',
    players: 'players',
    male: 'male',
    female: 'female',
    enterLocation: 'Enter location',
    weather: 'Weather',
    events: 'Events',
    noEvents: 'No active events',
    loadingWeather: 'Loading...',
  },

  // Location types
  locationTypes: {
    disco: 'Disco',
    bar: 'Bar',
    restaurant: 'Restaurant',
    library: 'Library',
    park: 'Park',
    cinema: 'Cinema',
    theater: 'Theater',
    cafe: 'Cafe',
    mall: 'Mall',
    beach: 'Beach',
    club: 'Club',
    landmark: 'Landmark',
    museum: 'Museum',
    gallery: 'Gallery',
    stadium: 'Stadium',
  },

  // Location screen
  location: {
    backToMap: 'Map of',
    openNow: 'Open',
    closedNow: 'Closed',
    peopleHere: 'People here',
    scenarios: 'Scenarios',
    info: 'Info',
    createSituation: 'Create situation',
    inviteToMeeting: 'Invite to date',
    workingHours: 'Working hours',
    status: 'Status',
    avgPrice: 'Average price for two',
    dresscode: 'Dress code',
    noise: 'Noise',
    capacity: 'Capacity',
    petsAllowed: 'Pets allowed',
    voiceChat: 'Voice chat',
    goodForFirstDate: 'Good for first date',
    workingHoursByType: 'Working hours by location type',
    here: 'here',
  },

  // Chat
  chat: {
    title: 'Messages',
    typeMessage: 'Type a message...',
    send: 'Send',
    aiAdvisor: 'AI Advisor',
    voiceCall: 'Voice call',
    endCall: 'End call',
    calling: 'Calling...',
    inCall: 'In call',
    micOn: 'Microphone on',
    micOff: 'Microphone off',
    callEnded: 'Call ended',
    callError: 'Call error',
  },

  // Notifications
  notifications: {
    title: 'Notifications',
    noNotifications: 'No notifications',
    markAllRead: 'Mark all read',
    newLike: 'New like!',
    newMessage: 'New message',
    welcome: 'Welcome!',
  },

  // Settings
  settings: {
    title: 'Settings',
    subtitle: 'Manage your account and preferences',
    account: 'Account',
    accountDesc: 'Update your public profile information',
    displayName: 'Display name',
    email: 'Email address',
    emailReadOnly: 'Email cannot be changed.',
    bio: 'Short bio',
    bioPlaceholder: 'Tell something about yourself...',
    notificationsSection: 'Notifications',
    notificationsDesc: 'Control when and how you receive notifications',
    channels: 'Channels',
    notifTypes: 'Notification types',
    privacy: 'Privacy',
    gameNotifications: 'In-game notifications',
    gameNotificationsDesc: 'System and game notifications',
    emailNotifications: 'Email notifications',
    emailNotificationsDesc: 'Receive notifications by email',
    soundEffects: 'Sound effects',
    soundEffectsDesc: 'Sounds for new messages and likes',
    matchNotifs: 'New likes',
    matchNotifsDesc: 'When someone likes you',
    messageNotifs: 'Messages',
    messageNotifsDesc: 'New chat messages',
    eventNotifs: 'Events and quests',
    eventNotifsDesc: 'New challenges and seasonal events',
    onlineStatus: 'Online status',
    profileVisibility: 'Profile visibility',
    public: '🌍 Public',
    friends: '👥 Friends',
    private: '🔒 Private',
    password: 'Password',
    passwordDesc: 'Update your account password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    newPasswordHint: 'Minimum 6 characters',
    confirmPassword: 'Confirm new password',
    passwordTip: 'Password must be at least 6 characters. Use a combination of letters, numbers and special characters for better security.',
    changePassword: 'Change password',
    language: 'Language',
    languageDesc: 'Choose your preferred interface language',
    applyLanguage: 'Apply language',
    danger: 'Danger zone',
    dangerDesc: 'Irreversible actions with your account',
    deleteAccount: 'Delete account',
    deleteAccountDesc: 'Deleting your account is irreversible. All your data, progress, achievements and history will be deleted forever.',
    deleteAccountBtn: 'Delete my account',
    deleteConfirmLabel: 'Type DELETE to confirm',
    deleteForever: 'Delete forever',
    deleting: 'Deleting...',
    signOut: 'Sign out',
    signOutDesc: 'Sign out of the current session on all devices.',
    signOutBtn: 'Sign out',
    save: 'Save changes',
    saveNotifs: 'Save preferences',
    saved: 'Settings saved!',
    accountUpdated: 'Account updated successfully!',
    passwordChanged: 'Password changed successfully!',
    languageApplied: 'Language set successfully.',
    saveError: 'Error saving.',
    passwordError: 'Error changing password.',
    passwordMismatch: 'Passwords do not match.',
    passwordTooShort: 'Password must be at least 6 characters.',
    fillAllFields: 'Fill in all fields.',
    enterValidName: 'Enter a valid name.',
    cancel: 'Cancel',
  },

  // Profile
  profile: {
    rating: 'Rating',
    reviews: 'reviews',
    leaveReview: 'Leave a review',
    traits: 'Traits',
    memories: 'Memories',
    attraction: 'Attraction',
  },

  // Situations
  situations: {
    createTitle: 'Create situation',
    createDesc: 'Describe a situation you want to be in with another player',
    inviteTitle: 'Invite to date',
    inviteDesc: 'Send a date invitation to another player',
    situationType: 'Situation type',
    message: 'Message',
    send: 'Send',
    cancel: 'Cancel',
    sent: 'Invitation sent!',
    types: {
      coffee: '☕ Coffee',
      walk: '🚶 Walk',
      dinner: '🍽️ Dinner',
      cinema: '🎬 Cinema',
      concert: '🎵 Concert',
      spontaneous: '⚡ Spontaneous',
    },
  },

  // Bulgarian grammar helpers (kept for compatibility, English doesn't need gendered forms)
  grammar: {
    inCity: {
      varna: 'in Varna',sofia: 'in Sofia',plovdiv: 'in Plovdiv',burgas: 'in Burgas',
    },
    adjectives: {
      beautiful: { male: 'handsome', female: 'beautiful' },
      poor: { male: 'poor', female: 'poor' },
      smart: { male: 'smart', female: 'smart' },
      rich: { male: 'rich', female: 'rich' },
      cold: { male: 'cold', female: 'cold' },
      ambitious: { male: 'ambitious', female: 'ambitious' },
      busy: { male: 'busy', female: 'busy' },
      fun: { male: 'fun', female: 'fun' },
      unreliable: { male: 'unreliable', female: 'unreliable' },
      family: { male: 'family-oriented', female: 'family-oriented' },
      caring: { male: 'caring', female: 'caring' },
      athletic: { male: 'athletic', female: 'athletic' },
      disciplined: { male: 'disciplined', female: 'disciplined' },
      artistic: { male: 'artistic', female: 'artistic' },
      emotional: { male: 'emotional', female: 'emotional' },
      shy: { male: 'shy', female: 'shy' },
      sincere: { male: 'sincere', female: 'sincere' },
      thin: { male: 'slim', female: 'slim' },
      average: { male: 'average', female: 'average' },
      athletic2: { male: 'athletic', female: 'athletic' },
      large: { male: 'large', female: 'large' },
    },
  },

  // Dating History
  datingHistory: {
    title: 'Dating History',subtitle: 'All your past dates, results and statuses',totalDates: 'Total dates',romantic: 'Romantic',active: 'Active',avgRating: 'Average rating',outcomes: 'Outcomes',topLocations: 'Top locations',avgCompatibility: 'Average compatibility',filterAll: 'All',filterRomantic: 'Romantic',filterOngoing: 'Ongoing',filterFriendly: 'Friendly',filterFailed: 'Failed',noResults: 'No dates in this category',noResultsDesc: 'Change the filter to see more',dateDetails: 'Date details',location: 'Location',date: 'Date',compatibility: 'Compatibility',notes: 'Notes',highlight: 'Highlight',statTitle: 'Statistics',
  },

  // Discovery
  discovery: {
    title: 'Discover Players',subtitle: 'compatible players found',swipeView: 'Swipe',listView: 'List',filters: 'Filters',applyFilters: 'Apply filters',filterTitle: 'Search filters',city: 'City',gender: 'Gender',allCities: 'All',allGenders: 'All',men: 'Men',women: 'Women',ageRange: 'Age range',minRating: 'Minimum rating',allRatings: 'All',interests: 'Interests',openToTalk: 'Open to talk only',compatibility: 'compatibility',sortBy: 'Sort by',sortCompatibility: 'By compatibility',sortRating: 'By rating',sortAge: 'By age',liked: 'liked',skipped: 'skipped',remaining: 'remaining',swipeRight: 'Swipe right to like · Swipe left to skip',likeBtn: 'Like',likedBtn: 'Liked',skipBtn: 'Skip',
    undoBtn: 'Undo',resetDeck: 'Reset deck',toMap: 'To map',allSeen: 'You\'ve seen all!',
    allSeenDesc: 'Change filters or reset the deck.',
    noPlayers: 'No players found',
    noPlayersDesc: 'Change filters to see more results.',
    likedToast: 'You liked',
    openToTalkBadge: 'Open',
    viewProfile: 'View full profile →',
  },

  // Challenges
  challenges: {
    title: 'Challenges',
    subtitle: 'Complete quests, earn rewards, climb the leaderboard',
    season: 'Season: Spring',
    seasonEnds: 'Ends in 12 days',
    seasonXp: 'Season XP',
    level: 'Level',
    tabs: {
      quests: 'Quests',
      streak: 'Streaks',
      leaderboard: 'Leaderboard',
      rewards: 'Rewards',
    },
    quests: {
      daily: 'Daily quests',
      seasonal: 'Seasonal quests',
      all: 'All',
      completed: 'completed',
      difficulty: {
        easy: 'Easy',
        medium: 'Medium',
        hard: 'Hard',
        legendary: 'Legendary',
      },
    },
    streak: {
      title: 'Streak',
      days: 'consecutive days',
      longest: 'Longest streak',
      thisWeek: 'This week',
      milestones: 'Streak rewards',
      daysLeft: 'days',
    },
    leaderboard: {
      weekly: 'Weekly',
      seasonal: 'Seasonal',
      alltime: 'All time',
      yourRank: 'Your rank',
      full: 'Full leaderboard',
    },
    rewards: {
      dailyTitle: 'Daily login rewards',
      seasonTitle: 'Season rewards',
      claim: 'Claim',
      claimed: 'Claimed',
      tiers: {
        bronze: 'Bronze',
        silver: 'Silver',
        gold: 'Gold',
        platinum: 'Platinum',
      },
    },
  },

  // Achievements
  achievements: {
    title: 'Achievements',
    subtitle: 'achievements unlocked',
    unlocked: 'Unlocked',
    locked: 'Locked',
    xpEarned: 'XP earned',
    legendary: 'Legendary',
    allCategories: 'All',
    nextGoals: 'Next goals',
    rarityLegend: 'Badge rarity',
    unlockedOn: 'Unlocked on',
    xpReward: 'XP reward',
    progress: 'Progress',
    categories: {
      dates: 'Dates',
      matches: 'Likes',
      social: 'Social',
      exclusive: 'Exclusive',
      special: 'Special',
    },
    rarity: {
      common: 'Common',
      rare: 'Rare',
      epic: 'Epic',
      legendary: 'Legendary',
    },
  },
};

export type TranslationKeys = typeof en;
export default en;
